<div class="row g-3">
  <div class="col-12 col-md-9 order-md-1">
    <form [formGroup]="form">
    <div class="card mb-3">
      <div class="card-header">{{ 'authenticated.account.form.profile_details' | translate }}</div>
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <label for="lastName" class="form-label">{{ 'authenticated.account.form.last_name' | translate }}</label>
            <div class="input-group">
              <input id="lastName" type="text" class="form-control" formControlName="last_name">
            </div>
          </div>
          <div class="col-6">
            <label for="firstName" class="form-label">{{ 'authenticated.account.form.first_name' | translate }}</label>
            <div class="input-group">
              <input id="firstName" type="text" class="form-control" formControlName="first_name">
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <label for="email" class="form-label">{{ 'authenticated.account.form.email' | translate }}</label>
            <div class="input-group">
              <input id="email" type="text" class="form-control" formControlName="email">
            </div>
          </div>
          <div class="col-6">
            <label for="phone" class="form-label">{{ 'authenticated.account.form.phone' | translate }}</label>
            <div class="input-group">
              <input id="phone" type="text" class="form-control" formControlName="phone">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">{{ 'authenticated.account.form.company_details' | translate }}</div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <label for="companyName" class="form-label">{{ 'authenticated.account.form.company' | translate }}</label>
            <div class="input-group">
              <input id="companyName" type="text" class="form-control" formControlName="company">
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <label for="companyStreet" class="form-label">{{ 'authenticated.account.form.street' | translate }}</label>
            <div class="input-group">
              <input id="companyStreet" type="text" class="form-control" formControlName="street">
            </div>
          </div>
          <div class="col-6">
            <label for="companyHousenumber" class="form-label">{{ 'authenticated.account.form.housenumber' | translate }}</label>
            <div class="input-group">
              <input id="companyHousenumber" type="text" class="form-control" formControlName="street_number">
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <label for="companyPostcode" class="form-label">{{ 'authenticated.account.form.postcode' | translate }}</label>
            <div class="input-group">
              <input id="companyPostcode" type="text" class="form-control" formControlName="zip_code">
            </div>
          </div>
          <div class="col-6">
            <label for="companyCity" class="form-label">{{ 'authenticated.account.form.city' | translate }}</label>
            <div class="input-group">
              <input id="companyCity" type="text" class="form-control" formControlName="city">
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <label for="companyCountry" class="form-label">{{ 'authenticated.account.form.country' | translate }}</label>
            <div class="input-group">
              <input id="companyCountry" type="text" class="form-control" formControlName="country">
            </div>
          </div>
          <div class="col-6">
            <label for="companyUrl" class="form-label">{{ 'authenticated.account.form.url' | translate }}</label>
            <div class="input-group">
              <input id="companyUrl" type="text" class="form-control" formControlName="url">
            </div>
          </div>
        </div>
      </div>
    </div>
    </form>
  </div>
</div>
